import React from "react";
import { motion } from "framer-motion";

const BrandQuote = () => {
  return (
    <section className="py-20 px-6 bg-gradient-to-r from-purple-800 to-blue-800 text-white">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <div className="text-6xl mb-6">"</div>
          <blockquote className="text-3xl md:text-4xl font-bold mb-8 leading-relaxed italic">
            I don't create singers or producers.<br />
            I help people believe in themselves as original artists.
          </blockquote>
          <p className="text-xl md:text-2xl font-semibold text-purple-200">
            — Mukesh Rathore
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default BrandQuote;
